import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Number$isFinite from "@babel/runtime-corejs3/core-js/number/is-finite";
import React from "react";
import PropTypes from "prop-types";
const QueueContext = /*#__PURE__*/React.createContext();
export const useSnackbarQueueContext = () => React.useContext(QueueContext);
export const useSnackbarQueue = () => {
  const cleanTimer = React.useRef();
  const dismissTimer = React.useRef();
  const [queue, setQueue] = React.useState([]);
  const first = queue[0];
  const clean = id => {
    setQueue(q => _flatMapInstanceProperty(q).call(q, el => {
      if (el.id === id && el.visible === false) {
        return [];
      }
      return el;
    }));
  };
  const timeoutClean = React.useCallback(id => {
    if (cleanTimer.current) {
      clearTimeout(cleanTimer.current);
    }
    cleanTimer.current = _setTimeout(() => {
      clean(id);
      cleanTimer.current = null;
    }, 500);
  }, []);
  const push = el => {
    setQueue(q => [...q, {
      ...el,
      visible: true
    }]);
  };
  const dismissFirst = React.useCallback(id => {
    setQueue(q => {
      let found = false;
      return _mapInstanceProperty(q).call(q, el => {
        if (el.id === id && el.visible && !found) {
          found = true;
          return {
            ...el,
            visible: false
          };
        }
        return el;
      });
    });
    timeoutClean(id);
  }, [timeoutClean]);
  React.useEffect(() => {
    if (first && _Number$isFinite(first.dismissTimeout)) {
      dismissTimer.current = _setTimeout(() => {
        dismissFirst(first.id);
      }, first.dismissTimeout);
    }
    return () => {
      clearTimeout(dismissTimer.current);
    };
  }, [first, dismissFirst]);
  React.useEffect(() => () => clearTimeout(cleanTimer.current), []);
  return React.useMemo(() => ({
    push,
    getData: id => {
      if (id === (first === null || first === void 0 ? void 0 : first.id)) {
        return first.data;
      }
      return null;
    },
    isVisible: id => {
      var _queue$;
      return id === ((_queue$ = queue[0]) === null || _queue$ === void 0 ? void 0 : _queue$.id) && queue[0].visible === true;
    },
    dismissAll: id => {
      setQueue(q => _mapInstanceProperty(q).call(q, el => {
        if (el.id === id && el.visible) {
          return {
            ...el,
            visible: false
          };
        }
        return el;
      }));
      timeoutClean(id);
    },
    dismissFirst,
    clean
  }), [queue, timeoutClean, dismissFirst, first]);
};
export const SnackbarProvider = _ref => {
  let {
    children
  } = _ref;
  const queue = useSnackbarQueue();
  return /*#__PURE__*/React.createElement(QueueContext.Provider, {
    value: queue
  }, children);
};
process.env.NODE_ENV !== "production" ? SnackbarProvider.propTypes = {
  children: PropTypes.node
} : void 0;